import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';
import { AdminService } from '../../../service/admin.service';

@Component({
  selector: 'app-investment-consultations-tab',
  templateUrl: './investment-consultations-tab.component.html',
  styleUrls: ['./investment-consultations-tab.component.css'],
  standalone: true,
  imports: [CommonModule, TableModule, PaginatorModule, TagModule, InputTextModule, FormsModule, LucideIconsModule]
})
export class InvestmentConsultationsTabComponent implements OnInit {
  consultations: any[] = [];
  totalRecords = 0;
  loading = true;
  searchTerm: string = '';
  private searchSubject = new Subject<string>();

  constructor(private adminService: AdminService) {
    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.loadConsultations(undefined, searchTerm);
    });
  }

  ngOnInit(): void {
    this.loadConsultations();
  }

  loadConsultations(event?: any, search: string = this.searchTerm): void {
    this.loading = true;
    const page = event ? event.first / event.rows + 1 : 1;
    const limit = event ? event.rows : 10;

    this.adminService.getInvestmentConsultations(page, limit, search).subscribe(
      (response: any) => {
        this.consultations = response.data.consultations;
        this.totalRecords = response.data.pagination.totalItems;
        this.loading = false;
      },
      (error: any) => {
        console.error('Error fetching consultations:', error);
        this.loading = false;
      }
    );
  }

  onSearch(): void {
    this.searchSubject.next(this.searchTerm);
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.onSearch();
  }

}
